import * as Sentry from '@sentry/browser';

const _VUMEDI_PREFIX = '_VUMEDI_';

export const UserStoreKey = {
    PlaybackRate: 'PLAYBACK_RATE',
    VolumeLevel: 'VOLUME_LEVEL',
};

export const UserStore = {
    _getStorage() {
        if (window.localStorage) {
            return window.localStorage;
        }

        if (window.sessionStorage) {
            return window.sessionStorage;
        }

        return null;
    },
    _load(key) {
        const storage = this._getStorage();

        if (!storage) {
            return null;
        }

        try {
            return storage.getItem(`${_VUMEDI_PREFIX}${key}`);
        } catch (e) {
            Sentry.withScope((scope) => {
                const err = new Error(
                    `UserStore._load: could not retrieve key '${_VUMEDI_PREFIX}${key}' from storage '${storage}'.`,
                );

                scope.setFingerprint(['UserStore._load read error']);
                Sentry.captureException(err);
            });

            return null;
        }
    },
    _save(key, value) {
        const storage = this._getStorage();

        if (!storage) {
            return;
        }

        try {
            storage.setItem(`${_VUMEDI_PREFIX}${key}`, JSON.stringify(value));
        } catch (e) {
            Sentry.withScope((scope) => {
                const err = new Error(
                    `UserStore._save: could not save key '${_VUMEDI_PREFIX}${key}' to storage '${storage}'.`,
                );

                scope.setFingerprint(['UserStore._save error']);
                Sentry.captureException(err);
            });
        }
    },
    loadPlaybackRate() {
        const rateString = this._load(UserStoreKey.PlaybackRate);
        const rateNumber = window.parseFloat(rateString);

        if (Number.isNaN(rateNumber)) {
            return undefined;
        }

        return rateNumber;
    },
    savePlaybackRate(rate) {
        this._save(UserStoreKey.PlaybackRate, rate);
    },
    loadVolumeLevel() {
        const volumeString = this._load(UserStoreKey.VolumeLevel);
        const volumeNumber = window.parseFloat(volumeString);

        if (Number.isNaN(volumeNumber)) {
            return undefined;
        }

        return volumeNumber;
    },
    saveVolumeLevel(level) {
        this._save(UserStoreKey.VolumeLevel, level);
    },
};
